import type { CellContext } from '@tanstack/react-table'
import { Edit, Trash2 } from 'lucide-react'

import {
  DropdownMenuItem,
  DropdownMenuSeparator,
  RowActionsMenu,
} from '@/components/ui'
import type { Transaction } from '@/modules/projects'
import {
  DeleteTransactionsDialog,
  EditTransactionDialog,
} from '@/modules/projects/components'
import { useDialogActions } from '@/stores/dialog'

export const RowActionsCell = (cell: CellContext<Transaction, unknown>) => {
  const { openDialog } = useDialogActions()
  const transaction = cell.row.original
  const noun = transaction.typename === 'CheckRecord' ? 'Check' : 'Transaction'

  return (
    <RowActionsMenu label={`${noun} actions`}>
      <DropdownMenuItem
        onClick={() => openDialog(EditTransactionDialog.id, transaction)}
      >
        <Edit className="h-4 w-4" />
        Edit {noun}
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem
        onClick={() => openDialog(DeleteTransactionsDialog.id, [transaction])}
        destructive
      >
        <Trash2 className="h-4 w-4" />
        Delete {noun}
      </DropdownMenuItem>
    </RowActionsMenu>
  )
}
